<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/role"
                saveRoot="/role"
                @onSave="onSave"
                @onRequestSuccess="onRequestSuccess"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.role">
            <slot slot="afterForm">
                <b-row>
                    <b-col class="card-columns">
                        <b-card v-for="capsGroup, capsGroupIndex in dataCapsGroups">
                            <div slot="header">
                                {{capsGroup.label}}
                            </div>
                            <b-row v-for="cap, capIndex in capsGroup.caps">
                                <b-col>
                                    <b-badge class="pull-left mr-3 mt-2" :class="{ 'badge-info': cap.riskLevel == 1, 'badge-warning': cap.riskLevel == 2, 'badge-danger': cap.riskLevel == 3 }"><i class="fa fa-warning"></i></b-badge>
                                    <InputCheckbox
                                            :label="cap.label"
                                            :labelCols="10"
                                            v-model="dataCapsGroups[capsGroupIndex].caps[capIndex].selected"
                                            :description="cap.info"></InputCheckbox>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </slot>
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/role"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du rôle')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce rôle?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../components/DynamicForm'
    import InputCheckbox from '../components/InputCheckbox'
    import ModalTrash from '../components/ModalTrash'
    export default {
        name: 'Role',
        components: {
            DynamicForm,
            InputCheckbox,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    role: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: window.Core.Definition.getDefinition('Rôle'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'name'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'name',
                                type: 'text',
                                label: window.Core.Definition.getDefinition('Nom'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onSave() {
                let caps = []
                for(let capsGroup in this.dataCapsGroups) {
                    capsGroup = this.dataCapsGroups[capsGroup]
                    for(let cap in capsGroup.caps) {
                        cap = capsGroup.caps[cap]
                        caps.push(cap)
                    }
                }
                this.$refs.dynamicForm.addSaveArg('caps', caps, window.Core.Value.typeJSON)
            },
            onRequestSuccess(data) {
                if (data.capsGroups !== undefined) {
                    this.dataCapsGroups = data.capsGroups
                }
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/systeme/roles')
            }
        }
    }
</script>
